import React from 'react';
import { Menu, MenuList, MenuItem, MenuPopover } from '@fluentui/react-components';
import type { MenuProps } from '@fluentui/react-components';
import { observer } from 'owa-mobx-react';
import { ribbonCustomize } from './RibbonCustomizerContextMenu.locstring.json';
import loc from 'owa-localize';

export interface RibbonCustomizerContextMenuProps {
    anchorX: number;
    anchorY: number;
    onDismiss: () => void;
    onCustomizeClick: () => void;
}

export const RibbonCustomizerContextMenu: React.FC<RibbonCustomizerContextMenuProps> = observer(
    function RibbonCustomizerContextMenu({ anchorX, anchorY, onDismiss, onCustomizeClick }) {
        const positioning: MenuProps['positioning'] = React.useMemo(
            () => ({
                target: {
                    getBoundingClientRect: () => ({
                        top: anchorY,
                        left: anchorX,
                        bottom: anchorY + 1,
                        right: anchorX + 1,
                        x: anchorX,
                        y: anchorY,
                        height: 1,
                        width: 1,
                        toJSON() {
                            return this;
                        },
                    }),
                },
                position: 'after' as const,
                align: 'top' as const,
                autoSize: 'height' as const,
            }),
            [anchorX, anchorY]
        );

        return (
            <Menu
                positioning={positioning}
                open={true}
                onOpenChange={onDismiss}
                closeOnScroll={true}
            >
                <MenuPopover>
                    <MenuList>
                        <MenuItem onClick={onCustomizeClick}>{loc(ribbonCustomize)}</MenuItem>
                    </MenuList>
                </MenuPopover>
            </Menu>
        );
    },
    'RibbonCustomizerContextMenu'
);
